module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "item",
    staticClass: "accordionList-item",
    class: _vm.customClassesItem
  }, [(!_vm.injected) ? _c('div', {
    staticClass: "header",
    class: _vm.customClassesHeader,
    attrs: {
      "data-group": _vm.stayTopFixedGroup
    },
    on: {
      "click": _vm.toggleActive
    }
  }, [_vm._t("header", [_vm._v("Header")])], 2) : _vm._e(), (!_vm.isLoading) ? _c('div', {
    staticClass: "accordionList-body",
    class: {
      doNotFixFooter: _vm.injected
    }
  }, [_vm._t("body", [_vm._v("Body")])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f8c089c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Accordion/Accordion-Item.vue
// module id = 891
// module chunks = 13